<template><MySpaceTasksWidgets type="personalTasks" /></template>
<script>
import MySpaceTasksWidgets from './MySpaceTasksWidgets'
export default { name: 'MySpacePersonalTasksWidget', components: { MySpaceTasksWidgets } }
</script>
